module.exports = __webpack_public_path__ + "zvetseni-prsou_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_2_before.jpg
// module id = 1324
// module chunks = 0